import { render, staticRenderFns } from "./tournamentTeams.vue?vue&type=template&id=e749f4d6&scoped=true&"
import script from "./tournamentTeams.vue?vue&type=script&lang=js&"
export * from "./tournamentTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e749f4d6",
  null
  
)

export default component.exports